<template>
  <div class="content pad-t-20 pad-b-20">
    {{ message }}
  </div>
</template>

<script>
import AuthService from '../services/AuthService.js'
import ErrorMessages from '../providers/ErrorMessages.js'
import config from '../config.js'

export default {
  name: 'Auth',
  data() {
    return {
      message: null,
      authService: AuthService,
      errorMessages: ErrorMessages,
    }
  },
  mounted() {
    this.authenticate()
  },
  methods: {
    async authenticate() {
      try {
        this.message = this.errorMessages.signingIn
        const urlParams = new URLSearchParams(window.location.search)

        if (
          !urlParams.has('organizationId') ||
          !urlParams.has('organizationGuid') ||
          !urlParams.has('userGuid')
        ) {
          this.message = this.errorMessages.missingRequiredCondoParams
          return false
        }

        if (urlParams.has('authData')) {
          let authData = JSON.parse(urlParams.get('authData'))
          await this.$store.dispatch('setAccessToken', authData.access_token)
          await this.$store.dispatch('setRefreshToken', authData.refresh_token)
        } else {
          await this.$store.dispatch('setAccessToken', config.userToken)
        }

        const organizationId = urlParams.get('organizationId')
        const userGuid = urlParams.get('userGuid')
        const organizationGuid = urlParams.get('organizationGuid')
        await this.$store.dispatch('setCurrentOrganizationId', organizationId)
        await this.$store.dispatch('setCondoUserId', userGuid)
        await this.$store.dispatch('setCondoOrganizationId', organizationGuid)

        // Проверяем наличие всех необходимых данных
        const requiredData = {
          userToken: localStorage.getItem('userToken'),
          condoUserId: localStorage.getItem('condoUserId'),
          condoOrganizationId: localStorage.getItem('condoOrganizationId'),
          currentOrganizationId: localStorage.getItem('currentOrganizationId'),
        }

        if (!requiredData.userToken) {
          throw new Error('Missing userToken after authentication')
        }

        if (
          !requiredData.condoUserId ||
          !requiredData.condoOrganizationId ||
          !requiredData.currentOrganizationId
        ) {
          throw new Error(
            'Missing required organization parameters after setting'
          )
        }

        await this.$router.push({
          name: 'Intercom',
        })
      } catch (error) {
        console.error('Authentication failed:', error)
        this.message = 'Authentication error: ' + error.message
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
